import React, { useEffect, useState } from 'react';
import '../css/DeleteConfirmModal.css';

export function useDeleteConfirm() {
  const [pending, setPending] = useState(null);
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const ask = (item) => {
    setError('');
    setBusy(false);
    setPending(item);
  };

  const clear = () => {
    setPending(null);
    setError('');
    setBusy(false);
  };

  return { pending, error, busy, setError, setBusy, ask, clear };
}

export default function DeleteConfirmModal({ name, onConfirm, onCancel, error, busy, detail }) {
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === 'Escape' && !busy) onCancel();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [busy, onCancel]);

  const label = (name || '').trim() || 'this';

  return (
    <div
      className="confirm-delete-modal-overlay"
      role="alertdialog"
      aria-modal="true"
      aria-labelledby="confirm-delete-title"
      aria-describedby="confirm-delete-desc"
      onClick={() => { if (!busy) onCancel(); }}
    >
      <div
        className="confirm-delete-modal-panel"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 id="confirm-delete-title" className="confirm-delete-modal-title">
          Confirm Delete
        </h2>
        <p id="confirm-delete-desc" className="confirm-delete-modal-body">
          Are you sure you want to delete
          <span className="confirm-delete-modal-name">{label}?</span>
        </p>
        {detail ? (
          <p className="confirm-delete-modal-detail">{detail}</p>
        ) : null}
        {error ? (
          <div className="confirm-delete-modal-error" role="alert">
            {error}
          </div>
        ) : null}
        <div className="confirm-delete-modal-actions">
          <button
            type="button"
            className="confirm-delete-modal-btn confirm-delete-modal-btn--confirm"
            onClick={onConfirm}
            disabled={busy}
          >
            Confirm
          </button>
          <button
            type="button"
            className="confirm-delete-modal-btn confirm-delete-modal-btn--cancel"
            onClick={onCancel}
            disabled={busy}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}
